import type { FeatureResult } from '@growthbook/growthbook';
import type { AnalyticsEventMap } from '../types/events';

export function toFeatureFlagProps(
  key: string,
  result: FeatureResult<unknown>,
  sentFlags: Record<string, string>,
): AnalyticsEventMap['Feature Flag Applied'] | null {
  if (result.source !== 'force') return null;

  const variation = typeof result.value === 'string' ? result.value : JSON.stringify(result.value);
  if (sentFlags[key] === variation) return null;

  return {
    'Feature Flag': key,
    'Variation': variation,
  };
}
